/**
 * 도움말 블록의 클래스 문자열.
 *
 * 읽기 화면(`DocsBodyRenderer` → blocks/*)과 에디터 NodeView 가 **같은 문자열**을
 * 봐야 대표님이 편집하며 보는 모양과 발행 뒤 모양이 갈라지지 않는다.
 * 컴포넌트 파일에서 내보내면 react-refresh 규칙에 걸려서 여기로 뺐다.
 */

export const STEPS_LIST =
  'my-6 [counter-reset:docs-step]';

export const STEP_ITEM =
  "relative grid grid-cols-[1.875rem_1fr] gap-3.5 pb-5 before:absolute before:top-[1.875rem] before:bottom-0 before:left-[0.906rem] before:w-px before:bg-neutral-200 before:content-[''] last:pb-0 last:before:hidden dark:before:bg-white/12";

export const STEP_MARKER =
  'relative z-10 grid h-[1.875rem] w-[1.875rem] place-items-center rounded-full bg-brand-500 text-[13px] font-bold text-white [counter-increment:docs-step] before:content-[counter(docs-step)]';

export const STEP_TITLE =
  'mt-1 text-[15px] font-bold text-neutral-900 dark:text-neutral-100';

export const STEP_BODY =
  'mt-1.5 text-[14.5px] leading-7 text-neutral-600 dark:text-neutral-400';

export const INLINE_CODE =
  'rounded border border-neutral-200 bg-neutral-100 px-1.5 py-px font-mono text-[13px] font-normal text-[#b23c17] dark:border-white/12 dark:bg-white/8 dark:text-[#f0a882]';

export type CalloutTone = 'tip' | 'warn' | 'danger';

export const CALLOUT_STYLE: Record<
  CalloutTone,
  { box: string; head: string; icon: string; label: string }
> = {
  tip: {
    box: 'border-brand-200 bg-brand-50 text-brand-900 dark:border-brand-500/30 dark:bg-brand-500/10 dark:text-brand-100',
    head: 'text-brand-700 dark:text-brand-300',
    icon: '☞',
    label: '도움말',
  },
  warn: {
    box: 'border-warning/40 bg-warning/10 text-amber-900 dark:border-warning/30 dark:bg-warning/10 dark:text-amber-200',
    head: 'text-amber-700 dark:text-amber-300',
    icon: '⚠',
    label: '주의',
  },
  danger: {
    box: 'border-danger/40 bg-danger/10 text-red-900 dark:border-danger/30 dark:bg-danger/10 dark:text-red-200',
    head: 'text-danger dark:text-red-300',
    icon: '⛔',
    label: '경고',
  },
};

export const CALLOUT_BOX =
  'my-6 grid grid-cols-[1.25rem_1fr] gap-3 rounded-xl border px-4 py-3.5 text-sm leading-7';
